import { StreamName } from "../StreamName"
import { ManualInput } from "../ManualInput"
import { ManualVar } from "@/types/common"
import { InfoCard } from "../InfoCard"
import { NodeState } from "@/components/FlowSheetEditor/services/modal"
import { getUnitAttributes } from "@/components/FlowSheetEditor/components/Header/Simulation/Workbook/VariableTable/attributes"
import { getVarAttribute, variableLabel } from "../utils"
import { useGetUnitEntity } from "@/pages/Project/hooks/useUnitEntity"
import { useGetVarUnitCode } from "@/pages/Project/hooks/useVarUnit"
import { useMemo } from "react"
import { useGetVariableUnit } from "@/pages/Project/hooks/useDimUnits"

interface InNozzle {
  index: number
  unitId: string
  name: string
  f: ManualVar
  dp: ManualVar
}

export interface NozzleInTableProps {
  data: InNozzle[]
  title: string
  className?: string
  unit: NodeState
}

export const NozzleInTable = (props: NozzleInTableProps) => {
  const {data, title, className, unit} = props
  const getUnitEntityByCode = useGetVariableUnit()

  const units = useMemo(() => {
    return {
      dp: getUnitEntityByCode('DPRES'),
      flow: getUnitEntityByCode('MOL_F')
    }
  }, [getUnitEntityByCode])

  return <InfoCard title={title} className={className}>
    <table style={{width: '100%'}} className="bordered-table break-word-table table-mt">
      <thead>
        <tr>
          <th scope="col" style={{width: 60}}>Port #</th>
          <th scope="col">Stream</th>
          <th scope="col">{variableLabel('Flow', units.flow)}</th>
          <th scope="col">{variableLabel('DP', units.dp)}</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item) => {
          return <tr>
          <td>{item.index}</td>
          <td>{item.unitId ? <StreamName unitId={item.unitId}/> : '-'}</td>
          <td>
            <ManualInput
              data={item.f}
              attrKey={`:IN${item.index}:F`}
              unit={unit}
              dimCode="MOL_F"
            />
          </td>
          <td>
            <ManualInput
              data={item.dp}
              dimCode="DPRES"
              attrKey={`:DP${item.index}:DP`}
              unit={unit}
            />
          </td>
        </tr>
        })}
        
      </tbody>
    </table>
  </InfoCard>
}